import { environment } from '../../environments/environment';
import { CanActivateFn } from '@angular/router';
import { StorageService } from '../Service/storage.service';
import { inject } from '@angular/core';

export const redirectGuard: CanActivateFn = (route) => {
  const storageService = inject(StorageService); // ✅ Inject service here
  const isForOTPVerifiedFlow = route.queryParams['IsForOTPVerifiedFlow'];
  const isParams = isForOTPVerifiedFlow !== null && isForOTPVerifiedFlow !== undefined;

  if (isParams) {
    storageService.setItem("isForOTPVerifiedFlow", isForOTPVerifiedFlow ? "true" : "false");
  }

  const allowedDomains = environment.redirectDomainUrl;
  const currentDomain = window.location.hostname;

  if (
    window.location.href.includes('/#/Redirect') &&
    !allowedDomains.some(d => d.toLowerCase() === currentDomain?.toLowerCase()) &&
    !isParams
  ) {
    // navigate to dashboard if domain not allowed
    window.location.href = '/#/Dashboard';
    return false;
  }

  return true;
};